import React from 'react';
import DetailProduct from './pages/DetailProduct'
import Product from './pages/Product'
import {Route, BrowserRouter, Switch} from 'react-router-dom';

function App() {
  return (
   <BrowserRouter>
    <Switch>
      <Route path="/" exact component={Product}/>
      <Route path="/product" exact component={Product}/>
      <Route path="/product/:id" exact component={DetailProduct}/>
    </Switch>
   </BrowserRouter>
  );
}

export default App;
